<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'Filters',
        body: [
          `The filters allow the user to select a person type, person
          identifier type, source system, District and/or School from a
          dropdown menu. The options available are determined by the user’s
          security access. In addition, the user may enter the person
          identifier number and/or last name. Entering more data will narrow
          the result set returned.`,
        ],
      },
      {
        header: 'Running the Report',
        body: [
          `Once the user has selected and entered the desired parameters, click
          Customize. The Alias ID Report Results panel will appear. This panel
          contains a person list for the district, school or person selected in
          the filter parameters. The panel list contains the State ID, Name,
          Location Information and Alias ID counts. The user may drill into -
          result set record to see the Alias ID details.`,
        ],
      },
      {
        header: 'Drilling into the Report',
        body: [
          `On the Alias ID Report Results panel, the user can drill into the
          Alias ID list for the individual selected by clicking the hyperlinked
          the double arrow, drill-in icon under Actions. Drilling in takes the
          user to the person level where the user can view the Alias IDs,
          status, location information, person type, source system,
          and creation/update dates.`,
        ],
      },
      {
        header: 'Downloading the Report',
        body: [
          `The user may select Generate Excel or Generate PDF reports on any
          level of the Alias ID Report Results panel. Generate XLS will create
          a spreadsheet which the user will download through the web browser.
          Generate PDF will create a PDF file which the user can print or save.`,
        ],
      },
    ];
  },
};
</script>
